import {
  Avatar,
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  IconButton,
  SimpleGrid,
  Text,
  VStack,
  Spinner,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FaStar, FaTrash } from "react-icons/fa";
import { useEffect, useState } from "react";
import { db, collection, getDocs, deleteDoc, doc } from "../firebase";
import { MdAdd } from "react-icons/md";
import TestimonialUpload from "./TestimonialUpload"; // Add Upload Modal

const TestimonialsPanel = ({ adminMode }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure(); // For upload modal
  const toast = useToast();

  //   useEffect(() => {
  //     uploadTestimonials();
  //   }, []);
  // Enable Admin Mode

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "testimonials"));
      const testimonialsList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTestimonials(testimonialsList);
    } catch (error) {
      console.error("🔥 Error fetching testimonials:", error);
    }
    setLoading(false);
  };

  /** Function to delete a testimonial */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this testimonial?"))
      return;

    try {
      await deleteDoc(doc(db, "testimonials", id));

      // Update UI after deletion
      setTestimonials((prev) =>
        prev.filter((testimonial) => testimonial.id !== id)
      );

      toast({
        title: "Testimonial deleted!",
        description: "The testimonial has been removed.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error deleting testimonial:", error);
      toast({
        title: "Error",
        description: "Could not delete testimonial.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box h={{ base: "100%", md: "65vh" }} overflow={"auto"}>
      <HStack justify="space-between" width="100%" my={2}>
        <Heading size="md">What Our Customers Say</Heading>
        {adminMode && (
          <Button
            fontWeight="normal"
            size="xs"
            colorScheme="green"
            onClick={onOpen}
            leftIcon={<MdAdd />}
          >
            Add
          </Button>
        )}
      </HStack>
      <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600" mb={4}>
        We take great pride in the quality of our work and the satisfaction of
        our customers. Here’s what some of our happy clients have to say about
        our services.
      </Text>
      <TestimonialUpload
        isOpen={isOpen}
        onClose={onClose}
        fetchTestimonials={fetchTestimonials}
      />{" "}
      {/* Upload Modal */}
      {/* Show Spinner While Loading */}
      {loading ? (
        <Spinner size="lg" color="blue.500" />
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {testimonials.map((testimonial) => (
            <Box
              key={testimonial.id}
              bg="gray.50"
              p={4}
              borderRadius="sm"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.200"
              position="relative"
            >
              {/* 🔥 Delete Button in Top-Right (Only in Admin Mode) */}
              {adminMode && (
                <IconButton
                  aria-label="Delete testimonial"
                  icon={<FaTrash />}
                  colorScheme="red"
                  size="xs"
                  position="absolute"
                  top={2}
                  right={2}
                  onClick={() => handleDelete(testimonial.id)}
                />
              )}

              <HStack spacing={4} align="start">
                {/* Avatar */}
                <Avatar
                  size={{ base: "sm", md: "md" }}
                  src={testimonial.avatar}
                  name={testimonial.name}
                />

                <VStack align="start" spacing={1} flex="1">
                  {/* Name & Location */}
                  <Heading size="sm">{testimonial.name}</Heading>
                  <Text fontSize="xs" color="gray.500">
                    {testimonial.location}
                  </Text>

                  {/* 5-Star Rating */}
                  <HStack spacing={1}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Icon key={i} as={FaStar} color="yellow.400" />
                    ))}
                  </HStack>

                  {/* Customer Comment */}
                  <Text
                    fontSize={{ base: "xs", md: "sm" }}
                    fontStyle="italic"
                    mt={2}
                  >
                    "{testimonial.comment}"
                  </Text>
                </VStack>
              </HStack>
            </Box>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default TestimonialsPanel;
